import { render, staticRenderFns } from "./AnswerUserTest.vue?vue&type=template&id=02136c94&scoped=true"
import script from "./AnswerUserTest.vue?vue&type=script&lang=js"
export * from "./AnswerUserTest.vue?vue&type=script&lang=js"
import style0 from "./AnswerUserTest.vue?vue&type=style&index=0&id=02136c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02136c94",
  null
  
)

export default component.exports